import styles from  "./AlertProductDetail.module.scss";
import { Card, CardContent } from "@material-ui/core";
import Tooltip from "../Tooltip";
import { LazyLoadImage } from "react-lazy-load-image-component";
import epcIcon from "assets/images/epc-icon.svg";
import i18n from "i18n";

const AlertProductDetail = ({ tag, product, processAlert }) => {
  return (
    <Card className={styles["alert-product-detail-card"]} component="article">
      <header>
        <h5>{i18n.t("product.detail")}</h5>
        <button onClick={processAlert}>{i18n.t("process.alarm")}</button>
      </header>

      <CardContent className={styles["alert-product-detail-card__content"]}>
        <section className={styles["alert-product-detail-card__content--info"]}>
          <picture>
            <LazyLoadImage
              width={"100%"}
              height={"100%"}
              src={product?.image}
              effect="blur"
            />
          </picture>
          <div>
            <h3>{product?.name}</h3>
            <h4>SKU {product?.sku}</h4>
            {product?.description.length > 228 ? (
              <Tooltip
                content={<p>{product?.description}</p>}
                text={product?.description}
              />
            ) : (
              <p>{product?.description}</p>
            )}
          </div>
        </section>

        <section className={styles["alert-product-detail-card__content--properties"]}>
          <div className={styles["alert-product-detail-card__content--properties__prop"]}>
            <picture>
              <img src={epcIcon} alt="EPC" />
            </picture>
            <div>
              <p>EPC</p>
              <h3>{tag?.rfid || "-"}</h3>
            </div>
          </div>
        </section>
      </CardContent>
    </Card>
  );
};

export default AlertProductDetail;
